export default __webpack_public_path__ + "static/media/iotroom.e15d04a4.png";